require('./payrollLoanContentKOXDTI.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @components
const PayrollLoanRequestLowerBiggerImport = require('../../contractPayrollLoan/payrollLoanRequestLowerBiggerImport/payrollLoanRequestLowerBiggerImport');
const { findPurposeById } = require('../../contractPayrollLoan/payrollLoanPurposes');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');

class PayrollLoanContentKOXDTI extends React.Component {

    constructor(props) {
        super(props);
        this.buildTitle = this.buildTitle.bind(this);
        this.buildSubtitle = this.buildSubtitle.bind(this);
    }

    buildSubtitle() {
        const { immPayrollLoanRequest } = this.props;
        if (!immPayrollLoanRequest.get('isFetchingValidateAmountKOxDTI')) {
            const lowerImport = immPayrollLoanRequest.get('lowerKOxDTI');
            let nameValueAmount;
            if (lowerImport) {
                nameValueAmount = "payrollLoanLayoutKOxDTI-subtitleLowerAmount1";
            } else {
                nameValueAmount = "payrollLoanLayoutKOxDTI-subtitleBiggerAmount1";
            }
            const amountMax = immPayrollLoanRequest.get('maxAmount');
            const currencyValue = getFormattedString({ amount: amountMax, currency: immPayrollLoanRequest.get('currency') });
            const subtitleKOxDTI = currencyValue + formatText('payrollLoanLayoutKOxDTI-subtitleAmount2') + immPayrollLoanRequest.get('minTerm');
            return (
                <div className="payroll-loan-layout-koxdti__subtitle">
                    <div>
                        <i className="icon payroll-loan-layout-koxdti__icon rebrand-loans" />
                    </div>
                    <div className="payroll-loan-layout-koxdti__content-subtitle">
                        <FormattedText value={nameValueAmount} />
                        {subtitleKOxDTI}
                        <FormattedText value="payrollLoanLayoutKOxDTI-subtitleAmount3" />
                    </div>
                </div>
            );
        } else {
            return <LoadingSection />;
        }
    }

    buildTitle() {
        const { immPayrollLoanRequest, isDragoFeature } = this.props;

        let purposeText;
        if (isDragoFeature) {
            const purposeElement = immPayrollLoanRequest.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immPayrollLoanRequest.get('selectedPurposeDrago'));
            purposeText = !!purposeElement ? purposeElement.get('text') : '';
        } else {
            const selectedPurpose = findPurposeById(immPayrollLoanRequest.get('selectedPurpose'));
            purposeText = selectedPurpose ? formatText(selectedPurpose.payrollLoanRequestTransKey) : undefined;
        }
        const titleText = formatText('payrollLoanLayoutKOxDTI-titleAmount', [purposeText]);
        return (
            <div className="payroll-loan-layout-koxdti__title">
                {titleText}
            </div>
        );
    }

    render() {
        const { immPayrollLoanRequest, getInstallment, setLoanAmount, setLoanTerm,
            getMinTerm, validateAmountKOxDTI } = this.props;
        const title = this.buildTitle();
        const subtitle = this.buildSubtitle();

        return (
            <div>
                <div className="payroll-loan-layout-koxdti__card">
                    <div className="payroll-loan-layout-koxdti__container">
                        {title}
                        <div className="payroll-loan-layout-koxdti__body">
                            {subtitle}
                        </div>
                    </div>
                </div>
                <PayrollLoanRequestLowerBiggerImport
                    getInstallment={getInstallment}
                    setLoanAmount={setLoanAmount}
                    getMinTerm={getMinTerm}
                    setLoanTerm={setLoanTerm}
                    immPayrollLoanRequest={immPayrollLoanRequest}
                    validateAmountKOxDTI={validateAmountKOxDTI}
                />
            </div>
        );
    }
}

PayrollLoanContentKOXDTI.propTypes = {
    immPayrollLoanRequest: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    validateAmountKOxDTI: PropTypes.func.isRequired,
};


module.exports = PayrollLoanContentKOXDTI;
